import React, { Component } from 'react'

export default class DiscussionInboxList extends Component {
    render() {
        return (
            <div>
                
            </div>
        )
    }
}
